import { useCallback, useRef } from "react";

const Spotlight = ({ children, className="" }) => {
  const ref = useRef(null);
  const onMove = useCallback(e=>{if(!ref.current)return;const r=ref.current.getBoundingClientRect();ref.current.style.setProperty("--sx",`${e.clientX-r.left}px`);ref.current.style.setProperty("--sy",`${e.clientY-r.top}px`)},[]);
  return <div ref={ref} className={`relative ${className}`} onMouseMove={onMove} style={{background:"radial-gradient(600px circle at var(--sx,50%) var(--sy,50%),rgba(196,162,101,0.05),transparent 60%)"}}>{children}</div>;
};
export default Spotlight;